import { render, staticRenderFns } from "./rightcard2.vue?vue&type=template&id=551ee6f6&scoped=true"
import script from "./rightcard2.vue?vue&type=script&lang=js"
export * from "./rightcard2.vue?vue&type=script&lang=js"
import style0 from "./rightcard2.vue?vue&type=style&index=0&id=551ee6f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551ee6f6",
  null
  
)

export default component.exports